<template><div><h3>CellBox_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fcell-box"/>
<p><a href="https://vux.li/demos/v2/#/component/cell-box" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/cell-box</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/cell-box" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"cell"</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"hello"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">cell</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell-box</span> <span class="hljs-attr">is-link</span>&gt;</span>
        cell-box long long long long long long long
      <span class="hljs-tag">&lt;/<span class="hljs-name">cell-box</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell-box</span>&gt;</span>
        cell-box hello world hello world hello world
      <span class="hljs-tag">&lt;/<span class="hljs-name">cell-box</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">cell</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"cell"</span> <span class="hljs-attr">value</span>=<span class="hljs-string">"hello"</span> <span class="hljs-attr">is-link</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">cell</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>

<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { Group, Cell, CellBox } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">components</span>: {
    Group,
    Cell,
    CellBox
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>
</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// cell-box-362.vue?d079effa